import {
  ApplicationConfig,
  provideZoneChangeDetection,
  importProvidersFrom, ErrorHandler,
} from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { routes } from './app.routes';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideDefaultCurrencyCode } from './core/providers/provideDefaultCurrencyCode';
import { provideLocaleId } from './core/providers/provideLocaleId';
import { provideAppInitializer } from './core/providers/provideAppInitializer';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { ToastComponent } from './shared/components/toast/toast.component';
import * as Sentry from "@sentry/angular-ivy";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    importProvidersFrom(FormsModule),
    provideAnimationsAsync(),
    provideAppInitializer(),
    provideDefaultCurrencyCode(),
    provideLocaleId(),
    provideHttpClient(
      withInterceptorsFromDi()
    ),
    provideAnimations(),
    provideToastr({
      closeButton: true,
      toastComponent: ToastComponent,
      disableTimeOut: true,
      tapToDismiss: false
    }),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
  ],
};
